import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-no-access-page',
    templateUrl: './no-access-page.component.html',
    styleUrls: ['./no-access-page.component.scss'],
    standalone: false
})
export class NoAccessPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
